import {Component, OnInit, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {LocationStrategy} from '@angular/common';
import * as $ from 'jquery';
import {ShapeOverlays} from './_services/svg';
import {ScrollEvent} from 'ngx-scroll-event';
import {ModalService} from './_common/modal/modal-service';

@Component({selector: 'app-root', templateUrl: './app.component.html'})

export class AppComponent implements OnInit,
AfterViewInit {

  // SVG Init
  @ViewChild('shapeOverlays')
  private elm: ElementRef;

  hideLoader = false;
  showContent = false;

  // Modal BG Blur
  blur: boolean;

  isPopState = false;

  scrollStatus = false;
  public handleScroll(event: ScrollEvent) {
    if (window.pageYOffset < 150) {
      this.scrollStatus = false;
    } else {
      this.scrollStatus = true;
    }
  }

  constructor(private router: Router, private locStrat: LocationStrategy, private _ModalService: ModalService) {}

  ngOnInit() {
    this
      ._ModalService
      .currentState
      .subscribe(state => {
        this.blur = state;
      });
    this.blur = false;

    this
      .locStrat
      .onPopState(() => {
        this.isPopState = true;
      });

    this
      .router
      .events
      .subscribe(event => {
        // Scroll to top if accessing a page, not via browser history stack
        if (event instanceof NavigationEnd && !this.isPopState) {
          window.scrollTo(0, 0);
          this.isPopState = false;
        }

        // Ensures that isPopState is reset
        if (event instanceof NavigationEnd) {
          this.isPopState = false;
        }
      });
  }

  ngAfterViewInit() {
    this.animation();
  }

  animation() {
    setTimeout(() => {
      this.hideLoader = true;
      setTimeout(() => {
        this.svgInit(this.elm, true);
        setTimeout(() => {
          this.showContent = true;
        }, 100);
      }, 1000);
    }, 700);
  }

  svgInit(elm, isOpened) {
    const overlay = new ShapeOverlays(elm, isOpened);
    if (overlay.isAnimating) {
      return false;
    }
    overlay.toggle();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts